import { render, staticRenderFns } from "./staffload.vue?vue&type=template&id=2a846300&"
import script from "./staffload.vue?vue&type=script&lang=js&"
export * from "./staffload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports